import SiteLayout from "@/components/feature/SiteLayout";
import TickerBar from "@/components/feature/TickerBar";
import HeroSection from "@/pages/home/components/HeroSection";
import LatestStories from "@/pages/home/components/LatestStories";
import TopicsSection from "@/pages/home/components/TopicsSection";
import CategorySection from "@/pages/home/components/CategorySection";
import PrinciplesSection from "@/pages/home/components/PrinciplesSection";
import TestimonialsSection from "@/pages/home/components/TestimonialsSection";
import FaqPreview from "@/pages/home/components/FaqPreview";
import SubmitCta from "@/pages/home/components/SubmitCta";
import { useSeo } from "@/hooks/useSeo";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "黑暗爆料",
    alternateName: "暗线 · 匿名爆料聚合",
    url: "https://heianbaoliao.example.com/",
    description:
      "聚合知情人、线人与内部人私下透露的独家内容，涵盖商业暗账、行业黑幕、职场内幕与灰色地带。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "https://heianbaoliao.example.com/stories?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "黑暗爆料",
    url: "https://heianbaoliao.example.com/",
    email: "tips@heianbaoliao.example.com",
    description: "匿名爆料与知情人揭底的聚合内容站，坚持先核实再发布，为被指涉方保留回应空间。",
  },
];

export default function Home() {
  useSeo({
    title: "黑暗爆料 - 匿名爆料与知情人揭底聚合站",
    description:
      "黑暗爆料聚合知情人、线人与内部人私下透露的独家内容，涵盖商业暗账、行业黑幕、职场内幕与灰色地带，呈现事件背后的真实口述与细节拼图。",
    keywords: "黑暗爆料,匿名爆料,知情人揭底,线人曝料,内部人私透,行业黑幕,职场内幕",
    path: "/",
    jsonLd,
  });

  useScrollReveal([]);

  return (
    <SiteLayout>
      <HeroSection />
      <TickerBar />
      <LatestStories />
      <TopicsSection />
      <CategorySection />
      <PrinciplesSection />
      <TestimonialsSection />
      <FaqPreview />
      <SubmitCta />
    </SiteLayout>
  );
}